var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-h4"},[_vm._v("What is your PRI variant?")]),_c('v-select',{attrs:{"label":"PRI Variant (Dynamic or TDM)","value":_vm.currentISDN,"persistent-hint":"","hint":"ISDN switch type","items":_vm.switchTypes},on:{"input":_vm.setPRIVariant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }